var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { markRaw, createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      d: "M8.27217 2.91422C8.43158 2.58428 8.90183 2.58428 9.06124 2.91422L10.737 6.39209C10.78 6.48125 10.8523 6.55349 10.9414 6.59652L14.4193 8.2723C14.7492 8.43171 14.7492 8.90195 14.4193 9.06136L10.9414 10.7371C10.8523 10.7802 10.78 10.8524 10.737 10.9416L9.06124 14.4194C8.90183 14.7494 8.43158 14.7494 8.27217 14.4194L6.59639 10.9416C6.55337 10.8524 6.48113 10.7802 6.39197 10.7371L2.9141 9.06136C2.58416 8.90195 2.58416 8.4317 2.9141 8.2723L6.39197 6.59652C6.48113 6.55349 6.55337 6.48125 6.59639 6.39209L8.27217 2.91422Z",
      fill: "currentColor"
    }, null, -1),
    createElementVNode("path", {
      d: "M3.724 1.50667C3.83559 1.27577 4.1645 1.27577 4.27608 1.50667L4.95056 2.90641C4.98069 2.96891 5.0313 3.01951 5.09379 3.04964L6.49353 3.72412C6.72442 3.83571 6.72442 4.16461 6.49353 4.2762L5.09379 4.95068C5.0313 4.98081 4.98069 5.03142 4.95056 5.09391L4.27608 6.49365C4.16449 6.72454 3.83559 6.72454 3.724 6.49365L3.04952 5.09391C3.01939 5.03142 2.96878 4.98081 2.90629 4.95068L1.50655 4.2762C1.27565 4.16462 1.27565 3.83571 1.50655 3.72412L2.90629 3.04964C2.96878 3.01951 3.01939 2.96891 3.04952 2.90641L3.724 1.50667Z",
      fill: "currentColor"
    }, null, -1)
  ]));
}
__name(render, "render");
const stars = markRaw({ name: "custom-stars", render });
export {
  stars as default
};
//# sourceMappingURL=stars.js.map
